import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Box, Stack, TextField } from '@mui/material';
import PhoneInput from '@acnb/CustomComponents/PhoneInput/PhoneInput';
import BooleanQuestion from './BooleanQuestion';

const DealerContactStep = ({ dealer, form, errors, update }) => {
  const { t } = useTranslation();

  return (
    <Stack spacing={4}>
      <Box
        component="img"
        src="/images/headers/project-request-form.jpg"
        alt={t('showroomProjectRequest.imageAlt')}
        sx={{ width: '100%', maxHeight: 300, objectFit: 'cover', borderRadius: 2 }}
      />
      <TextField label={t('showroomProjectRequest.dealerNumber')} value={dealer?.identifier || ''} disabled fullWidth />
      <TextField
        required
        label={t('showroomProjectRequest.contactName')}
        value={form.primaryContactName}
        onChange={event => update('primaryContactName', event.target.value)}
        error={errors.primaryContactName}
        helperText={errors.primaryContactName && t('showroomProjectRequest.required')}
        fullWidth
      />
      <TextField
        required
        type="email"
        label={t('showroomProjectRequest.contactEmail')}
        value={form.primaryContactEmail}
        onChange={event => update('primaryContactEmail', event.target.value)}
        error={errors.primaryContactEmail}
        helperText={errors.primaryContactEmail && t('showroomProjectRequest.required')}
        fullWidth
      />
      <TextField
        required
        type="tel"
        label={t('showroomProjectRequest.contactPhone')}
        value={form.primaryContactPhone}
        onChange={event => update('primaryContactPhone', event.target.value)}
        InputProps={{ inputComponent: PhoneInput }}
        InputLabelProps={{ shrink: true }}
        error={errors.primaryContactPhone}
        helperText={errors.primaryContactPhone && t('showroomProjectRequest.required')}
        fullWidth
      />
      <BooleanQuestion
        label={t('showroomProjectRequest.relocate')}
        value={form.plansToRelocateWithinTwoYears}
        onChange={value => update('plansToRelocateWithinTwoYears', value)}
        error={errors.plansToRelocateWithinTwoYears}
      />
      <BooleanQuestion
        label={t('showroomProjectRequest.discussedDsm')}
        value={form.hasDiscussedWithDsm}
        onChange={value => update('hasDiscussedWithDsm', value)}
        error={errors.hasDiscussedWithDsm}
      />
      {form.hasDiscussedWithDsm === false && <Alert severity="info">{t('showroomProjectRequest.skipDsmNotice')}</Alert>}
    </Stack>
  );
};

export default DealerContactStep;
